export const getLocalToken = () => localStorage.getItem('token');

export const saveLocalToken = (token: string) => localStorage.setItem('token', token);

export const removeLocalToken = () => localStorage.removeItem('token');

export const toBoolean = (str: string | undefined) => {return str?.toLowerCase() === 'true';}

export const getState = () => localStorage.getItem('state');

export const saveState = (state: string) => localStorage.setItem('state', state);

export const removeState = () => localStorage.removeItem('state');